/**
 * Defines the automatic resolution types for duplicate handling.
 */
export enum DuplicateAutoResolveTypeModel {
	/**
	 * Requires user input to resolve duplicates.
	 */
	WaitUserInput = 1,
	/**
	 * Automatically approves all duplicates.
	 */
	ApproveAll = 2,
	/**
	 * Automatically rejects all duplicates.
	 */
	RejectAll = 3
}
